
import axios from 'axios';
import { NetworkCheckDownloadOptions } from '../network-check';
import { ChipStatus } from '../../../../shared/ppr-chip-status/ppr-chip-status';
import { sleep } from '../../../../util/util';

export const DEFAULT_DOWNLOAD_CHECK: NetworkCheckDownloadOptions = {
  minSpeed: Number(process.env.REACT_APP_DOWNLOAD_SPEED_MIN) ?? 5,
  url: process.env.REACT_APP_DOWNLOAD_SPEED_CHECK_URL ?? '',
  fileSize: Number(process.env.REACT_APP_DOWNLOAD_SPEED_DOWNLOAD_SIZE) ?? 10485760,
  timeout: Number(process.env.REACT_APP_NETWORK_CHECK_TIMEOUT) ?? 20000
};

export const loadImage = async (url: string, timeout: number) => {
  try {
    const response = await axios.get(url, {
      timeout: timeout,
    });
    const result = response.data;
    return result;
  } catch (error) {
    console.error(error);
    throw new Error('Network unstable');
  }
};

export const checkDownloadSpeed = async (downloadCheckOptions: NetworkCheckDownloadOptions): Promise<{ downloadSpeed: number, downloadStatus: ChipStatus }> => {
  await sleep(1000);

  const startTime = new Date().getTime();
  const cacheBuster = `?nnn=${startTime}`;

  try {
    await loadImage(downloadCheckOptions.url + cacheBuster, downloadCheckOptions.timeout);
    const endTime = new Date().getTime();
    const bitsLoaded = downloadCheckOptions.fileSize * 8;
    const duration = (endTime - startTime) / 1000;
    const speedBps = bitsLoaded / duration;
    const speedKbps = speedBps / 1024;
    const speedMbps = speedKbps / 1024;

    return {
      downloadSpeed: Number(speedMbps.toFixed(2)),
      downloadStatus: speedMbps >= downloadCheckOptions.minSpeed ? 'passed' : 'failed'
    };
  } catch (error) {
    console.error(error);
    return {
      downloadSpeed: 0,
      downloadStatus: 'failed'
    };
  }
};
